/**
 * Query key factories for complex domains with coordinated cache invalidation
 *
 * These factories provide the static parts of query keys. TanStack Query's
 * invalidateQueries uses prefix matching, so these will invalidate all queries
 * that start with the returned key, regardless of additional parameters.
 *
 */

export const leadKeys = {
  all: ['lead'] as const,
  details: (uuid: string) => ['lead', 'details', uuid] as const,
  pendingActivities: (uuid: string) => ['lead', 'pending-activities', uuid] as const,
  activityHistory: (uuid: string) => ['lead-activity-history', uuid] as const,
  clientHistories: (uuid: string) => ['lead', 'client-histories', uuid] as const,
  contacts: (uuid: string) => ['lead', 'contacts', uuid] as const,
  surveys: (uuid: string) => ['lead', 'surveys', uuid] as const,
}

export const leadsKeys = {
  all: ['leads'] as const,
  list: () => ['leads', 'list'] as const,
  count: () => ['leads', 'count'] as const,
  metricsCount: () => ['leads', 'metrics-count'] as const,
  lastAccessed: () => ['leads', 'last-accessed'] as const,
}

export const actionCenterKeys = {
  all: ['action-center'] as const,
  notificationTypes: () => ['action-center', 'notification-types'] as const,
  notificationsCount: () => ['action-center', 'notifications-count'] as const,
  notificationMetricsConfig: () => ['action-center', 'notification-metrics-config'] as const,
  notificationSettings: () => ['action-center', 'notification-settings'] as const,
  notifications: () => ['action-center', 'notifications'] as const,
  history: () => ['action-center', 'history'] as const,
}

export const pushNotificationsKeys = {
  all: ['push-notifications'] as const,
  count: () => ['push-notifications', 'count'] as const,
  list: () => ['push-notifications', 'list'] as const,
}

export const internalChatKeys = {
  all: ['internal-chat'] as const,
  groups: () => ['internal-chat', 'groups'] as const,
  unreadCount: () => ['internal-chat', 'unread-count'] as const,
}

export const campaignKeys = {
  all: ['campaigns'] as const,
  // useGetCampaignsQuery keys on ['campaigns', <serialized query>]; prefix matching makes
  // this invalidate every filtered/paginated variant at once.
  lists: () => ['campaigns'] as const,
  detail: (id: string) => ['campaign', id] as const,
  leads: (id: string) => ['campaign-leads', id] as const,
}
